module.exports = __webpack_public_path__ + "img/panel8.2c06c07e.svg";